import { render, staticRenderFns } from "./Watchlist.vue?vue&type=template&id=7f8e59c1"
import script from "./Watchlist.vue?vue&type=script&lang=js"
export * from "./Watchlist.vue?vue&type=script&lang=js"
import style0 from "./Watchlist.vue?vue&type=style&index=0&id=7f8e59c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports